import React from "react";

const HeroSection = ({ title, description, video, brand }) => {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Background Video */}
      <video
        className="absolute backdrop-blur-3xl object-cover w-full h-full inset-0 bg-black/40 mix-blend-overlay z-[1]"
        style={{ filter: 'saturate(1.3)' }}
        src={video}
        autoPlay
        loop
        muted
        playsInline
      />
      {/* Dark Blur Overlay */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm z-[10]" />
      {/* Blue Overlay */}
      {/* <div className="absolute bg-blue-100/30"></div> */}

      {/* Frosted Glass Overlay Box */}
      <div className="relative z-[10] flex items-center justify-center h-full px-4">
        <div className="backdrop-blur-3xl bg-white/70 p-8 rounded-2xl shadow-xl text-center max-w-3xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-heading mb-4">
            {title}
          </h2>
          <h1 className="text-4xl md:text-5xl font-bold text-heading mb-4">
            {brand}
          </h1>
          <p className="text-lg text-gray-700">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
